import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist, InputSelect } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './personalinfotype-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
    personalinfotypeType?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class PersonalinfotypeView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} caption={this.props.caption} 
                model={Model} onLoad={this.onLoad}>   
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Personalinfotype' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }   
                {!this.props.personalinfotypeType &&
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                }
            </BaseView>
        );
    }
}